import React from 'react';
import './Checkbox.css';

const MarkForExportButton = ({ checked, onChange }) => {
  const labelStyle = {
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 8,
    fontSize: 12,
    gap: 8,
    cursor: 'pointer',
    fontStyle: 'italic',
  };

  return (
    <label style={labelStyle}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="custom-checkbox"
      />
      Mark For Export
    </label>
  );
};

export default MarkForExportButton;
